module.exports = {
      id: "gztrending-usage",
      viewBox: "0 0 18.806 24.145",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#gztrending",
      toString: function () {
        return this.url;
      }
    }